<template>
    <ArvaModal name="adjustCarbonCreditModal" title="Run Model" @close-modal="handleCloseModal">
        <div class="col">
            <span class="default-input-title">Please select the option you want to use to run the model.</span>
            <div class="flex justify-center">
                <v-radio-group row class="radio-group-row"
                    v-model="runModelType">
                    <div 
                        class="radio-wrapper">
                        <v-radio v-for="docType, idx in confirmRunModelTypes" :key="`${docType['name']}-${idx}`" :label="docType['name']" :value="docType"/>
                    </div>
                </v-radio-group>
            </div>
        </div>

        <ArvaModalSaveFooter confirmText="Confirm" cancelText="Cancel" @on-cancel="handleCloseModal"
            @on-confirm="setRunModelType" />
    </ArvaModal>
</template>

<script>
import ArvaModal from "./ArvaModal"
import ArvaModalSaveFooter from "@/components/modals/ArvaModalSaveFooter"

export default {
    name: "RunModelConfirmation",
    components: { ArvaModal, ArvaModalSaveFooter },
    data: () => ({
        confirmRunModelTypes: [
            { name: "Pasture wise", value: 1 },
            { name: "Paddock wise", value: 2 },
        ],
        runModelType: { name: "Pasture wise", value: 1 },
    }),

    methods: {
        handleCloseModal() {
            this.$emit("close-template-modal")
        },

        setRunModelType() {
            this.$emit("set-run-model-type", this.runModelType)
        },
    },

    // mounted() {
    //   this.dollarInput = this.carbonCreditDollarValue
    // },
}
</script>

<style scoped>
.radio-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
}
</style>